'use strict';
var aircraftmapUtils = require('components/bags_and_seats/aircraftmap_utils/js/aircraftmap.utils');
var AircraftMapTemplate = function(options) {
    aircraftmapUtils.options = aircraftmapUtils.parseOptions(options);
};

AircraftMapTemplate.prototype = {
    buildTemplate: function() {
        return $('<div>', {class: 'od-aircraftmap-map-wrapper'})
            .append(this.buildBody());
    },
    buildBody: function() {
        aircraftmapUtils.setSeatPriceData(aircraftmapUtils.options.seatMap.cabin);
        const $cabins = $('<div>', {class: 'od-aircraftmap-cabins od-keep-ltr'});
        Odigeo._.each(aircraftmapUtils.options.seatMap.cabin, Odigeo._.bind(function(cabin) {
            $cabins.append(this.buildCabin(cabin));
            const $darkZone = aircraftmapUtils.hasToShowDarkZone(cabin) ? aircraftmapUtils.addDarkZone(cabin) : '';
            $cabins.append($darkZone);
        }, this));
        return $cabins;
    },
    buildRowHeader: function(cabin) {
        const $el = $('<div>', {class: 'od-aircraftmap-columndistribution'});
        Odigeo._.each(cabin.cabinCharacteristics.columnDistribution, Odigeo._.bind(function(column) {
            if (column === 'AISLE') {
                $el.append($('<div>', {class: 'od-aircraftmap-aisle'}));
            } else {
                $el.append($('<div>', {class: 'od-aircraftmap-rowhead-seat odf-text-sm odf-strong'}).text(column));
            }
        }, this));
        $el.append($('<span>', {class: 'aircraftmap_anchor'}));
        return $el;
    },
    buildCabin: function(cabin) {
        const $cabin = $('<div>', {class: 'od-aircraftmap-cabin'});
        const exitRows = aircraftmapUtils.getCustomRowElement(cabin.cabinCharacteristics.exitRows, aircraftmapUtils.constants.BLANK_SPACE);
        let seatRow = cabin.firstSeatsRow;
        $cabin.append(this.buildRowHeader(cabin));
        Odigeo._.each(Odigeo._.range(cabin.seatMapRowFrom, cabin.seatMapRowTo + 1), Odigeo._.bind(function(seatMapRow) {
            const row = aircraftmapUtils.getSeatRowFromSeatMapRow(cabin, seatMapRow);
            const aircraftMapRowClasses = 'od-aircraftmap-row ';

            if (row === aircraftmapUtils.constants.BLANK_SEATS) {
                $cabin.append($('<div>', {class: aircraftMapRowClasses})
                    .append(this.buildNoSeatsRow(cabin, aircraftmapUtils.constants.BLANK_SEATS, seatMapRow)));
                seatRow++;
            } else if (row > aircraftmapUtils.constants.BLANK_SEATS) {
                seatRow = row > aircraftmapUtils.constants.NO_SEATS ? row : seatRow;
                const $aircraftmapRow = $('<div>');
                $aircraftmapRow.addClass(aircraftMapRowClasses);
                if (aircraftmapUtils.isExitRow(exitRows, seatRow.toString())) {
                    $aircraftmapRow.append(aircraftmapUtils.addExitRow(seatRow));
                }
                $cabin.append($aircraftmapRow.append(this.buildRow(cabin, seatRow, seatMapRow)));
                seatRow++;
            }
        }, this));
        return $cabin;
    },
    buildNoSeatsRow: function(cabin, seatRow, seatMapRow) {
        let elements = [];
        let $el = $('<div>', {class: 'odf-text-center od-aircraftmap-row-aisle'});
        Odigeo._.each(cabin.cabinCharacteristics.columnDistribution, Odigeo._.bind(function(columnCount) {
            if (columnCount === 'AISLE') {
                elements.push($el, $('<div>', {class: 'odf-text-center odf-text-sm od-aircraftmap-aisle'}).text('-'));
                $el = $('<div>', {class: 'odf-text-center od-aircraftmap-row-aisle'});
            } else {
                $el.append(this.buildSeat(aircraftmapUtils.getSeatCharacteristics(cabin, seatRow, seatMapRow, columnCount)));
            }
        }, this));

        elements.push($el);
        return elements;
    },
    buildRow: function(cabin, seatRow, seatMapRow) {
        let elements = [];
        let $el = $('<div>', {class: 'odf-text-center od-aircraftmap-row-aisle'});
        const extraLegSeats = aircraftmapUtils.getCustomRowElement(cabin.cabinCharacteristics.extraLegSeats, aircraftmapUtils.constants.BLANK_SPACE);
        Odigeo._.each(cabin.cabinCharacteristics.columnDistribution, Odigeo._.bind(function(columnCount) {
            if (columnCount === 'AISLE') {
                elements.push($el, $('<div>', {class: 'odf-text-center odf-text-sm od-aircraftmap-aisle'}).append(seatRow));
                $el = $('<div>', {class: 'odf-text-center od-aircraftmap-row-aisle'});
            } else {
                const $seat = aircraftmapUtils.isSeatExtraLeg(extraLegSeats, seatRow, columnCount)
                    ? this.buildExtraLegSeat(cabin, seatRow, seatMapRow, columnCount)
                    : this.buildSeat(aircraftmapUtils.getSeatCharacteristics(cabin, seatRow, seatMapRow, columnCount));
                $el.append($seat);
            }
        }, this));

        elements.push($el);
        return elements;
    },
    buildExtraLegSeat: function(cabin, seatRow, seatMapRow, columnCount) {
        const $extraLegSeat = $('<div>', {class: 'od-aircraftmap-row-extra-leg emergency_exit'});
        const $extraSpace = $('<div>', {class: 'od-aircraftmap-row-extra-leg-space'});
        const $seat = this.buildSeat(aircraftmapUtils.getSeatCharacteristics(cabin, seatRow, seatMapRow, columnCount));
        return $extraLegSeat
            .append($extraSpace)
            .append($seat);
    },
    buildSeat: function(seat) {
        return $('<div>', {class: this.getSeatStyle(seat)})
            .attr('id', 'aircraft_map_' + seat.row + seat.column)
            .attr('data-status', seat.status)
            .attr('data-rawprice', seat.rawPrice)
            .append(this.buildIcon(seat));
    },
    getSeatStyle: function(seat) {
        return 'aircraftmap_seat_' + seat.status + ' od-aircraftmap-seat-custom';
    },
    buildSeatAvailableType: function(seat) {
        const aircraftInfo = {
            cheaperSeatPrice: Odigeo._.get(aircraftmapUtils, 'options.cheaperSeatPrice'),
            differentSeatPrices: Odigeo._.get(aircraftmapUtils, 'options.differentSeatPrices'),
            preferredSeatsThreshold: Odigeo._.get(aircraftmapUtils, 'options.preferredSeatsThreshold'),
            section: Odigeo._.get(aircraftmapUtils, 'options.section'),
        };
        const seatMainCharacteristic = aircraftmapUtils.getSeatMainCharacteristic(seat, aircraftInfo);
        let seatClasses = 'aircraftmap_seat odf-icon od-aircraftmap-icon odf-text-xl ';
        if (seat.type === aircraftmapUtils.options.seatStatus.unavailable) {
            seatClasses += 'odf-icon-cross-light';
        } else if (aircraftmapUtils.isNoSeat(seat)) {
            seatClasses += 'od-aircraftmap-noseat ';
            if (!Odigeo._.isEmpty(seat.characteristics.characteristic)) {
                seatClasses += aircraftmapUtils.getNoSeatType(seat.characteristics.characteristic);
            }
        } else {
            seatClasses += aircraftmapUtils.hasExtraLegCharacteristic(seat)
                ? aircraftmapUtils.getExtraLegClasses()
                : aircraftmapUtils.hasPreferredSeatCharacteristic(
                    seat,
                    Odigeo._.get(aircraftmapUtils, 'options.preferredSeatsThreshold')
                )
                    ? aircraftmapUtils.getPreferredSeatClasses()
                    : this.printRegularSeat(seat);
        }
        return {
            classes: seatClasses,
            mainCharacteristic: seatMainCharacteristic,
        };
    },
    printRegularSeat: function(seat) {
        return this.getColouredSeatClasses(seat);
    },
    getColouredSeatClasses: function(seat) {
        const cheaperSeatPrice = Odigeo._.get(aircraftmapUtils, 'options.cheaperSeatPrice');
        const differentSeatPrices = Odigeo._.get(aircraftmapUtils, 'options.differentSeatPrices');
        return aircraftmapUtils.isCheaperSeatCharacteristic(seat, cheaperSeatPrice, differentSeatPrices)
            ? ' aircraftmap_cheaper_seat od-aircraftmap-default-seat-cheapest odf-icon-tag'
            : ' aircraftmap_default_seat od-aircraftmap-default-seat-primary';
    },
    buildIcon: function(seat) {
        const seatInfo = this.buildSeatAvailableType(seat);
        return $('<div>', {class: seatInfo.classes})
            .attr('data-row', seat.row)
            .attr('data-column', seat.column)
            .attr('data-type', seat.type)
            .attr('data-texttype', aircraftmapUtils.options.keys[seat.type])
            .attr('data-extra-leg', aircraftmapUtils.hasExtraLegCharacteristic(seat))
            .attr('data-price', seat.price)
            .attr('data-rawprice', seat.rawPrice)
            .attr('data-prime-price', seat.primePrice)
            .attr('data-prime-rawprice', seat.rawPrimePrice)
            .attr('data-characteristic', seatInfo.mainCharacteristic);
    },
};

module.exports = AircraftMapTemplate.prototype.constructor = AircraftMapTemplate;
